import { useGameStore } from '@/store/gameStore'
import { WeatherDisplay } from '../components/WeatherEvents'
import { SeasonalDisplay } from '../components/ExtraUI'
import { ConstructionTimer } from '../components/ConstructionTimer'
import { QuickSaveButton } from '../components/QuickSaveButton'
import { Calendar, Star, Menu } from 'lucide-react'
import { AnimatedNumber } from '../motion/AnimatedNumber'

interface HeaderProps {
  onToggleSidebar?: () => void
  isMobile?: boolean
}

// Broadcast HUD: a TV scoreboard strip — angled match clock on the left,
// club KPIs as scoreboard cells on the right.
export function Header({ onToggleSidebar, isMobile = false }: HeaderProps) {
  const { money, reputation, day, week, month, clubLevel } = useGameStore()

  return (
    <header className="hud-header">
      {/* Left: menu toggle (mobile) + match clock */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <button
          onClick={onToggleSidebar}
          className="sidebar-toggle"
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--text-secondary)',
            cursor: 'pointer',
            padding: '0.25rem',
          }}
        >
          <Menu size={20} />
        </button>

        <div className="hud-clock">
          <Calendar size={14} style={{ color: 'var(--gold)', alignSelf: 'center' }} />
          <span className="hud-clock-day">Día {day}</span>
          <span className="hud-clock-sub">Sem {week} · Mes {month}</span>
        </div>

        <div className="header-extras">
          <WeatherDisplay />
          <SeasonalDisplay />
        </div>

        {/* Outside header-extras so the works timer stays visible on mobile
            (header-extras is hidden there); CSS compacts it on small screens. */}
        <ConstructionTimer />
      </div>

      {/* Right: club scoreboard cells. Level + reputation are hidden on mobile
          (both shown on the Dashboard) so money always fits. */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        {!isMobile && <QuickSaveButton variant="header" />}

        <span className="hud-stat hud-hide-mobile">
          <span className="hud-stat-label">Nivel</span>
          {clubLevel}
        </span>

        <span className="hud-stat hud-hide-mobile">
          <Star size={13} style={{ color: 'var(--warning)' }} fill="currentColor" />
          {reputation.toFixed(1)}
        </span>

        <span className="hud-stat gold">
          <AnimatedNumber
            value={money}
            suffix="€"
            style={{
              fontWeight: 800,
              fontSize: '0.95rem',
              color: money >= 0 ? 'var(--gold)' : 'var(--danger)',
            }}
          />
        </span>
      </div>
    </header>
  )
}
